import { useEffect } from "react";

import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useCurrentAccountId } from "@zapier/payment/esm/hooks/useCurrentAccountId";
import {
  ApolloInjection,
  currencyRulesetQuery as currencyRulesetQueryData,
} from "@zapier/payment/esm/types";
import { logToSentry } from "@zapier/payment/esm/utils";

type Input = {
  accountId?: number | undefined;
} & ApolloInjection;

const currencyRulesetQuery = gql`
  query currencyRulesetQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currencyRuleset {
        currency
        method
        processor
        submethod
        submethodDisplay
      }
    }
  }
`;

function useCurrencyRuleset(props: Input = {}) {
  const currentAccount = useCurrentAccountId(props);
  const useQuery = props?.useQuery || defaultUseQuery;
  const accountId = props.accountId || currentAccount?.accountId;

  const { data, error, loading } = useQuery<currencyRulesetQueryData>(
    currencyRulesetQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  useEffect(() => {
    if (error) {
      logToSentry("currencyRuleset.load", error);
    }
  }, [error]);

  return {
    error: error ? "There was an issue loading data." : undefined,
    isLoading: loading,
    currencyRuleset: data?.account?.currencyRuleset ?? [],
  };
}

export { currencyRulesetQuery, useCurrencyRuleset };
